import { HttpService } from "./http.service";

const basePath = "/EventBlacklist";
const request = HttpService.handleRequest();

export const EventBlacklistService = {
  getByEventId
};

async function getByEventId(id) {
  return request.get(`${basePath}/GetByEventId/${id}`);
}

export default EventBlacklistService;